import { getPack } from './packs/registry';
import type { CleaningCycle } from './project';

const labels = new Map(getPack('cleaning').checklist.map((item) => [item.id,item.label]));

export function compareCleaningCycles(current:CleaningCycle, previous:CleaningCycle|null) {
  const before=new Set(previous?.scopeItemIds??[]);
  const now=new Set(current.scopeItemIds);
  return {
    added:[...now].filter((id)=>!before.has(id)),
    removed:[...before].filter((id)=>!now.has(id)),
    unchanged:[...now].filter((id)=>before.has(id))
  };
}

export const cycleItemLabel=(id:string)=>labels.get(id)??id;

export function orderedCleaningCycles(cycles:CleaningCycle[]) {
  return [...cycles].sort((left,right)=>right.serviceDate.localeCompare(left.serviceDate)||right.createdAt.localeCompare(left.createdAt));
}

export function previousCleaningCycle(cycle:CleaningCycle, cycles:CleaningCycle[]) {
  const ordered=[...cycles].sort((left,right)=>left.serviceDate.localeCompare(right.serviceDate)||left.createdAt.localeCompare(right.createdAt));
  const index=ordered.findIndex((row)=>row.id===cycle.id);
  return index>0?ordered[index-1]:null;
}
export function nextCycleDate(date:string,repeat:'weekly'|'fortnightly'|'monthly'){const [y,m,d]=date.split('-').map(Number);const next=new Date(Date.UTC(y,m-1,d));if(repeat==='monthly'){const lastDay=new Date(Date.UTC(y,m+1,0)).getUTCDate();next.setTime(Date.UTC(y,m,Math.min(d,lastDay)));}else next.setUTCDate(d+(repeat==='weekly'?7:14));return next.toISOString().slice(0,10);}
